module.exports = __webpack_public_path__ + "media/promo/promo/images/link-2-4ca47b8bdf1db66c94c857e6fe51ae5b.svg";